import React from 'react';
const defaultLocaleContext = {
  locale: '',
  localeOnChangeCallback: undefined,
  dateLocale: {}
};
const LocaleContext = React.createContext(defaultLocaleContext);
export const LocaleContextProvider = LocaleContext.Provider;
export const LocaleContextConsumer = LocaleContext.Consumer;
export default LocaleContext;